export default __webpack_public_path__ + "static/media/expert_3.b4e61cf4.png";